<div class="section">
  <h2 class="section-heading">{{ heading() | transloco }}</h2>
  <ng-content></ng-content>
</div>
